module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C3606"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("LIST ")]), _vm._v("OF FIGURES ")])]), _vm._v(" "), _c('div', {
    staticClass: "figleft"
  }, [_c('p', {
    staticClass: "C5863"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-first Century Distributed Supply Chains Mandates Manufacturing Change ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Business Evolves into Configurable Demand-Driven Supply Chains ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production Capability Configured Real-Time: Evaluate Customer Value/OTD to Production Path and Profit Margin ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Simplified’ Work Flow Complexity Matrix ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("1-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/08_Recogniz#id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Part 3 Sample B2M Interface Chart: Real-World B2M Interfaces Exist Within/Between MOM Activity Model Functions ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standards-Based Application Integration ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Domain Hierarchy from Purdue Reference Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Physical (Work/Resource) Hierarchy ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Data Flows of Interest Supporting Manufacturing Operations Management and Exchanges between Levels 3 and 4 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Information Categories (objects) Handled by Manufacturing Operations Management and Exchanged between Levels 3 and 4 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-6:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of ISA-95 Production Schedule Information Object Exchanged Between Level 4 and Level 3 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-7:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Generic Detailed Work Activity Model (Part 3) for MOM ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-8:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of ISA-95/OAGIS Transaction Composed of Two Basic Messages, Each Formed by an OAGIS Verb- B2MML Noun Combination ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-9:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of a Sequence of ISA-95 Transactions to Enable a Specific Business Process Scenario – Production Schedule Changes Based on Production Capability Input ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-10:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of Set of ISA-95 Transactions to Enable a Series of Level 4 to Level 3 to Support a Specific Business Process Scenario – Production Planning & Scheduling ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-11:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of P&G B2MML Application in B2M System Architecture ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-12:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAGIS Scope ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-13:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example OAGIS Integration Scenario ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-14:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standard OAGIS BOD Structure ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-15:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IBM EIMS - Current State: Customer Interfaces ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-16:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IBM EIMS - Target State: Canonical Format and Framework ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-17:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order Management and Order Status Message Interactions Scenario ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-18:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIMS Canonical Model – Reuse Methodology and Assets ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-19:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAGIS “Vendor Managed Inventory (Consumption) Scenario” ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-20:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAGIS “Production to Manufacturing Execution” Scenario ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-21:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ford UpdateVehicleOrderStatus BOD, based on OAGIS UpdateWIPConfirm ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-22:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#id_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAGIS Extensibility – Accommodating Multiple Parties within a Vertical ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_82",
      "id": "page_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("2-23:")])])]), _c('span', {
    attrs: {
      "href": "#/html/10_Overview#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overlay Extensions to the OAGIS ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/11_Chapter#id_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/11_Chapter#id_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manufacturing Integration Standards – An Overview ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Domain Hierarchy from Purdue Reference Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Physical (Work /Resource) Hierarchy ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example OAGIS Integration Scenario ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standard OAGIS BOD Structure ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-6:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAGIS Scope ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-7:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BatchML Master Recipe ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-8:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BatchML Equipment Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-9:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOR Organized around Five Major Management Processes ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-10:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOR’s Hierarchical Model with Three Level of Process Detail ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("3-11:")])])]), _c('span', {
    attrs: {
      "href": "#/html/12_ISA_95#id_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of STEP Systems ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Generic Approach to Developing of As-Is and To-Be Manufacturing Operations Studies ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03-2005 Typical Expanded Equipment Hierarchy ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Process Segments Example ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.01-2000 Functional Enterprise-Control Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Application Example of the Functional Enterprise-Control Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-6:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03-2005 MOM Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-7:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03.2005 Activity Model of Production Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-8:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03 Production Resource Management Activity Model Interfaces ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-9:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03-2005 Activity Model of Maintenance Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-10:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03-2005 Activity Model of Quality Test Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-11:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANSI/ISA-95.00.03-2005 Activity Model of Inventory Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-12:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview of MOM Activities ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("4-13:")])])]), _c('span', {
    attrs: {
      "href": "#/html/14_Introduc#id_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of a Recommended Architecture (To-Be situation) and Roadmap Priorities ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Manufacturing Enterprise Flows ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-88/95 Physical Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-88 Procedural Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Part 3 Manufacturing Operation Management Activity Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-88/95 Product Development Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-6:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-88/95 Fit to Production Life-cycles ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-7:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-88/95 Physical/Decisional Hierarchy ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-8:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temporal View of ISA-95 Activity Model ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-9:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manufacturing Information Systems Life-cycle ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_97",
      "id": "page_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-10:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Master Project Components ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-11:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationships between Master and Instance Projects ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-12:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Functional Core System Overview ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-13:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Functional Core System Development Process ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-14:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facility Model at the Heart of MIS ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-15:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modelling Process ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-16:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Functional Definition Process ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-17:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Task Consolidation ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("5-18:")])])]), _c('span', {
    attrs: {
      "href": "#/html/16_Scope_of#id_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Developing & Mapping Technical Core System ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISA-95 Part 3 Sample B2M Interface Chart: Real World B2M Interfaces Exist Within/Between MOM Activity Model Functions ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manufacturing Work Flow Agility Matrix ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865a"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-3A:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ProcessSegmentType Element of the B2MML Process Segment Schema ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5865a"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-3B:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ProcessSegment Element of the B2MML Process Segment Schema ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Level 3 Manufacturing Operations Information Exchanges Represented by B2MML ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuous Process Example ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-6:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#id_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Batch Processing Example ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/18_Introduc#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("6-7:")])])]), _c('span', {
    attrs: {
      "href": "#/html/18_Introduc#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discrete Manufacturing Example ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical Manufacturing Materials Costing Work Flow ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#page_199",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#page_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SON Functional Breakdown Structure ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Success Factors for Appendix 7-B Example ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("7-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/20_Overview#id_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Value Risk Index Chart with KPI Weight ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("8-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shop-floor to Top-floor Business Processes ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("8-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/22_Executiv#id_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Functional Hierarchy from ANSI/ISA-95.00.01-2000 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/22_Executiv#page_227",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("8-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/22_Executiv#page_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample System Architecture ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5871"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/24_Introduc#page_237",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9-1:")])])]), _c('span', {
    attrs: {
      "href": "#/html/24_Introduc#page_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOM Change Management Process ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9-2:")])])]), _c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activity Model of Production Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9-3:")])])]), _c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activity Model of Maintenance Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/24_Introduc#page_242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9-4:")])])]), _c('span', {
    attrs: {
      "href": "#/html/24_Introduc#page_242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activity Model of Quality Test Operations Management ")])]), _vm._v(" "), _c('p', {
    staticClass: "C5862"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("9-5:")])])]), _c('span', {
    attrs: {
      "href": "#/html/24_Introduc#id_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activity model of Inventory Operations Management ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c14951f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_List_of.vue
// module id = 69
// module chunks = 0